
<ul>
    @for( ballot of data; track $index) {
        <li><a [routerLink]="getNavRoute(ballot)">{{ballot.title}}</a></li>
    }
</ul>
